import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles, Heart } from "lucide-react";

const CTASection = () => {
  return (
    <section className="py-20 md:py-28 bg-gradient-hero relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      <div className="absolute -top-12 -right-12 w-96 h-96 bg-accent-light/30 rounded-full blur-3xl animate-blob-float-slow"></div>
      <div className="absolute -bottom-16 -left-16 w-[450px] h-[450px] bg-secondary-light/25 rounded-full blur-3xl animate-blob-float-medium"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="glass-cta max-w-5xl mx-auto rounded-3xl p-8 md:p-16 border border-white/20 shadow-2xl relative overflow-hidden">
          {/* Top highlight gradient */}
          <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-white/10 to-transparent pointer-events-none"></div>

          <div className="text-center text-white max-w-3xl mx-auto relative z-10">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-5 py-2 mb-8 shadow-lg shadow-primary-dark/10">
              <Sparkles className="w-4 h-4 text-accent-light animate-pulse" />
              <span className="text-sm font-semibold tracking-wide">Bergabung dengan 10,000+ Gen Z Indonesia</span>
            </div>

            {/* Headline */}
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-none">
              Kamu tidak pernah berjalan{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-light to-secondary-light">
                sendiri
              </span>
            </h2>

            {/* Subheadline */}
            <p className="text-lg md:text-xl text-white/85 mb-10 leading-relaxed font-medium">
              Kami hadir menemanimu dari awal hingga akhir, mendukung setiap langkah menuju
              kesehatan mental yang lebih baik bersama MindfulMe.
            </p>

            {/* Benefits */}
            <div className="flex flex-wrap justify-center gap-5 mb-12">
              <div className="flex items-center gap-2.5 bg-white/5 backdrop-blur-sm px-6 py-3 rounded-xl border border-white/10 shadow-sm">
                <Heart className="w-4 h-4 text-secondary-light fill-secondary-light animate-pulse" />
                <span className="text-sm font-medium">Gratis untuk memulai</span>
              </div>
              <div className="flex items-center gap-2.5 bg-white/5 backdrop-blur-sm px-6 py-3 rounded-xl border border-white/10 shadow-sm">
                <Sparkles className="w-4 h-4 text-accent-light animate-pulse" />
                <span className="text-sm font-medium">Setup 30 detik</span>
              </div>
              <div className="flex items-center gap-2.5 bg-white/5 backdrop-blur-sm px-6 py-3 rounded-xl border border-white/10 shadow-sm">
                <Heart className="w-4 h-4 text-secondary-light fill-secondary-light animate-pulse" />
                <span className="text-sm font-medium">100% Aman & Rahasia</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-5 justify-center mb-16">
              <Button 
                variant="hero" 
                size="lg" 
                className="group text-lg px-8 py-6 rounded-2xl shadow-xl shadow-primary-dark/20 hover:shadow-2xl hover:scale-[1.03] transition-all duration-300 font-semibold"
                onClick={() => window.open('https://app-mindfulme.pusatandalan.com/', '_blank')}
              >
                Coba Gratis Sekarang
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>

            {/* Trust indicators */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-2xl mx-auto text-center border-t border-white/10 pt-10">
              <div className="hover:scale-105 transition-transform duration-300">
                <div className="text-3xl font-extrabold text-white mb-1">4.9★</div>
                <div className="text-xs font-bold text-white/70 uppercase tracking-wider">Play Store Rating</div>
              </div>
              <div className="hover:scale-105 transition-transform duration-300">
                <div className="text-3xl font-extrabold text-white mb-1">10K+</div>
                <div className="text-xs font-bold text-white/70 uppercase tracking-wider">Happy Users</div>
              </div>
              <div className="hover:scale-105 transition-transform duration-300">
                <div className="text-3xl font-extrabold text-white mb-1">24/7</div>
                <div className="text-xs font-bold text-white/70 uppercase tracking-wider">Support</div>
              </div>
              <div className="hover:scale-105 transition-transform duration-300">
                <div className="text-3xl font-extrabold text-white mb-1">50+</div>
                <div className="text-xs font-bold text-white/70 uppercase tracking-wider">Psikolog</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;